import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { fontUi, viewMoreLink } from '../../../../theme/typography';

export const StyledTableContainer = styled.section`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const StyledMatchday = styled.span`
  ${fontUi};
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.textMuted};
  white-space: nowrap;
`;

export const StyledViewMore = styled(Link)`
  ${viewMoreLink};
  svg {
    display: block;
    width: 12px;
    height: 12px;
  }
`;

export const StyledContainer = styled.div`
  box-sizing: border-box;
  background: transparent;
  overflow: visible;
  padding: 0;
`;
